export class AdditionalQuestion {

    questionTypeCode : number | null;
    questionDescription : string;
    response : string;
    details : string;
    countryCode : string;
    code: string;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(jsonObject: any = null) {
    	this.questionTypeCode = null;
    	this.questionDescription = '';
    	this.response = '';
    	this.details = '';
    	this.countryCode = '';
    	this.code = '';
    	if (jsonObject !== null) {
             if (jsonObject instanceof AdditionalQuestion) {
                 this.questionDescription = jsonObject.questionDescription;
                 this.questionTypeCode = jsonObject.questionTypeCode;
                 this.response = jsonObject.response;
                 this.details = jsonObject.details;
                 this.countryCode = jsonObject.countryCode;
                 this.code = jsonObject.code;
             } else {
             	if (Object.prototype.hasOwnProperty.call(jsonObject, 'countryFlag')) {
             		const flag = jsonObject.countryFlag;
             		const parsed = Number(flag);
             		this.questionTypeCode = (flag !== null && flag !== '' && !isNaN(parsed)) ? parsed : null;
             	}
             	if (Object.prototype.hasOwnProperty.call(jsonObject, 'code')) {
             		this.code = jsonObject.code;
             	}
             	if (Object.prototype.hasOwnProperty.call(jsonObject, 'country')) {
             		this.countryCode = jsonObject.country;
             	}
             	if (Object.prototype.hasOwnProperty.call(jsonObject, 'details')) {
             		this.details = jsonObject.details;
             	}
             	if (Object.prototype.hasOwnProperty.call(jsonObject, 'response')) {
             		this.response = jsonObject.response;
             	}
             }
        }
    }
}
